import type { IAuthSession, IUser } from '@rpgc-ai/shared-interfaces/interfaces/auth.interface';

export interface AuthState {
  session: IAuthSession | null;
  user: IUser | null;
  isLoading: boolean;
  error: string | null;
}

export const initialAuthState: AuthState = {
  session: null,
  user: null,
  isLoading: false,
  error: null,
};
